// 1. Import your CONFIGURED api instance
import api from '@/plugins/axios';

// 2. Define the base path
const SERVICE_PATH = '/symbol-service/api/v1/transactions';

export default {
  getTransactionsByPortfolio(portfolioId) {
    // 3. Use the full path
    return api.get(SERVICE_PATH, { 
      params: { portfolioIds: portfolioId },
      paramsSerializer: function(params) {
        const searchParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          const value = params[key];
          if (Array.isArray(value)) {
            value.forEach(item => searchParams.append(key, item));
          } else {
            if (value !== undefined && value !== null) {
              searchParams.append(key, value);
            }
          }
        });
        return searchParams.toString();
      }
    });
  },

  getTransactionCount(userId) {
    return api.get(`${SERVICE_PATH}/count`, {
      params: { userId }
    });
  },

  createTransaction(transaction) {
    const formattedTransaction = {
      ...transaction,
      price: parseFloat(parseFloat(transaction.price).toFixed(10))
    };
    return api.post(SERVICE_PATH, formattedTransaction);
  },

  updateTransaction(transactionId, transaction) {
    return api.put(`${SERVICE_PATH}/${transactionId}`, transaction);
  },

  deleteTransaction(transactionId) {
    return api.delete(`${SERVICE_PATH}/${transactionId}`);
  },

  async deleteTransactionsBySymbol(symbolId) {
    try {
      const response = await api.delete(`${SERVICE_PATH}/symbol/${symbolId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting transactions by symbol:', error);
      throw error;
    }
  },
};
